import React from 'react';
import useTheme from '../context/hooks/useTheme';
import { ThemeKind, ThemePreference } from '../context/ThemeContext';
import DarkIcon from '../icons/Dark';
import LightIcon from '../icons/Light';
import SystemIcon from '../icons/System';

const OPTIONS: Record<ThemePreference, { label: string; Icon: React.FC<React.SVGProps<SVGSVGElement>> }> = {
    system: { label: 'System', Icon: SystemIcon },
    [ThemeKind.Light]: { label: 'Light', Icon: LightIcon },
    [ThemeKind.Dark]: { label: 'Dark', Icon: DarkIcon },
};

const ThemeSelection: React.FC = () => {
    const { preference, cyclePreference } = useTheme();
    const { label, Icon } = OPTIONS[preference];

    return (
        <button
            onClick={cyclePreference}
            title={`Theme: ${label}`}
            className="absolute sm:fixed top-4 right-4 sm:top-6 sm:right-6 w-9 h-9 rounded-full flex items-center justify-center text-ink-500 dark:text-ink-400 hover:text-accent dark:hover:text-accent-soft transition-colors z-10"
        >
            <Icon width={18} height={18} />
        </button>
    );
};

export default ThemeSelection;
